import { Lookup } from '../../../shared/model/lookup';

export class BillClassType extends Lookup {
  constructor(code: string, name: string) {
    super(code, name);
  }
}
